import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiContent } from "@/services/api-client/content";
import type {
  ExtractTalkingHeadFramesResponse,
  RunTaskTypeRequest,
} from "@/services/api-client/content/types";

import { contentKeys } from "./content.keys";

export const useRunTaskTypeMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ taskTypeId, req }: { taskTypeId: string; req: RunTaskTypeRequest }) =>
      apiContent.runTaskType(taskTypeId, req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: contentKeys.runs() });
    },
  });
};

export const useExtractTalkingHeadFrames = () =>
  useMutation<ExtractTalkingHeadFramesResponse, Error, File>({
    mutationFn: (video: File) => apiContent.extractTalkingHeadFrames(video),
  });
